// extracted by mini-css-extract-plugin
export default {"root":"TopBanner_root__jqVAV","media":"TopBanner_media__fgGgF"};